import { useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { formatCents } from '../lib/api';
import { useBundle } from './Bundle';
import { pct } from '../lib/pricing';

export default function MobileCartBar() {
  const cart = useCart();
  const location = useLocation();
  const { result } = useBundle();

  const hidden = cart.count === 0 || /^\/(cart|checkout)/.test(location.pathname);
  if (hidden) return null;

  return (
    <button
      type="button"
      onClick={() => cart.setOpen(true)}
      className="fixed inset-x-4 bottom-4 z-30 flex items-center justify-between gap-3 rounded-2xl bg-void px-5 py-4 text-white shadow-xl lg:hidden transition-all duration-200 hover:shadow-glow active:scale-[0.98]"
      aria-label="Open cart"
    >
      <span className="flex items-center gap-3 text-[15px] font-bold">
        <span className="grid h-7 min-w-[28px] place-items-center rounded-full bg-plug px-2 text-[13px] font-bold text-white shadow-sm">
          {cart.count}
        </span>
        View cart
      </span>
      <span className="flex items-center gap-2 text-[15px] font-bold tabular">
        {result.discount_cents > 0 && (
          <span className="rounded-full bg-plug/20 px-2 py-0.5 text-[11px] font-semibold text-plug">{pct(result.rate)} off</span>
        )}
        {formatCents(result.total_cents)}
      </span>
    </button>
  );
}
